module.exports = __webpack_public_path__ + "static/media/SM-ST-9.2df0e3f2.mp3";